import {Component, Input} from "@angular/core";

@Component({
  selector: 'nbinput-now',
  template: `
      <span >{{date | date: format}}</span>
    `
})
export class NbinputNowComponent {
  @Input() public format = 'yyyy-MM-dd HH:mm:ss';
  public date;

  constructor() {
    this.date =  new Date();
    setInterval(() => {
      this.date =  new Date();
    }, 1000);
  }
}
